import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Admin from './Admin';

ReactDOM.render(
  <React.StrictMode>
    <Admin />
  </React.StrictMode>,
  document.getElementById('root')
);
